import { Dependent } from 'shared/types/non-plan-year.types';
import { complement, isNil } from 'ramda';

function unhashCoveredDependents(covered: string[], all: Dependent[]) {
  return covered.map((strIdx) => all[parseInt(strIdx)])
    .filter(complement(isNil));
}

export default unhashCoveredDependents;
